<!-- ============================================================
     SOVEREIGN VIP COMMAND DOCK (PROFILE SUB-NAVIGATION)
     Brand New Concept: Horizontal Holographic Command Rail
     Replaces Old Vertical Side-Column with Sleek Top Command Bar
     ============================================================ -->

<div class="sovereign-command-dock" aria-label="Player System Navigation">
  
  <!-- Left Telemetry Badge -->
  <div class="dock-clearance-lockup hidden md:flex">
    <span class="dock-pulse-beacon"></span>
    <div class="flex flex-col">
      <span class="dock-clearance-tag">SYSTEM CLEARANCE</span>
      <span class="dock-clearance-title">PLAYER COMMAND</span>
    </div>
  </div>

  <!-- Horizontal Command Matrix -->
  <nav class="dock-nav-matrix">

    <!-- My Profile -->
    <button
      type="button"
      (click)="redirectUrl('/dashboard/profile')"
      class="dock-pill-btn"
      [class.is-engaged]="router.url.includes('profile') || router.url.includes('user-profile')"
    >
      <span class="dock-icon-box">
        <i class="far fa-user"></i>
      </span>
      <span class="dock-pill-text">My Profile</span>
      <span class="dock-laser-edge" aria-hidden="true"></span>
    </button>

    <!-- Security & Password -->
    <button
      type="button"
      (click)="redirectUrl('/dashboard/changePass')"
      class="dock-pill-btn"
      [class.is-engaged]="router.url.includes('changePass')"
    >
      <span class="dock-icon-box">
        <i class="fas fa-shield-alt"></i>
      </span>
      <span class="dock-pill-text">Security & Key</span>
      <span class="dock-laser-edge" aria-hidden="true"></span>
    </button>

    <!-- KYC Verification -->
    <button
      type="button"
      (click)="redirectUrl('/dashboard/KYCform')"
      class="dock-pill-btn"
      [class.is-engaged]="router.url.includes('KYCform')"
    >
      <span class="dock-icon-box">
        <i class="fas fa-fingerprint"></i>
      </span>
      <span class="dock-pill-text">KYC Clearance</span>
      <span class="dock-laser-edge" aria-hidden="true"></span>
    </button>

    <!-- Player Level -->
    <button
      type="button"
      (click)="redirectUrl('/dashboard/player-level')"
      class="dock-pill-btn"
      [class.is-engaged]="router.url.includes('player-level')"
    >
      <span class="dock-icon-box">
        <i class="fas fa-crown"></i>
      </span>
      <span class="dock-pill-text">VIP Tiers</span>
      <span class="dock-laser-edge" aria-hidden="true"></span>
    </button>

    <!-- Terms & Conditions -->
    <button
      type="button"
      (click)="redirectUrl('/dashboard/Terms&Conditions')"
      class="dock-pill-btn"
      [class.is-engaged]="router.url.includes('Terms&Conditions')"
    >
      <span class="dock-icon-box">
        <i class="fas fa-file-contract"></i>
      </span>
      <span class="dock-pill-text">Rules & Codex</span>
      <span class="dock-laser-edge" aria-hidden="true"></span>
    </button>

  </nav>

  <!-- Right Encrypted Protocol Pill -->
  <div class="dock-security-tag hidden lg:flex">
    <i class="fas fa-user-shield text-[#E7CA96]"></i>
    <span>256-BIT SECURE</span>
  </div>

</div>

<app-logoutmodel
  [isOpen]="isLogoutModalOpen"
  [profileImage]="profileImage"
  (onCancel)="closeLogoutModal()"
  (onConfirm)="logout()"
></app-logoutmodel>
